<!-- Omitted rather than drawn broken: an organization can be stored with an
     empty logo (qav3 is, on dev). -->
@if (logoUrl() !== "") {
  @if (featured()) {
    <!-- The rings are decoration; the image carries the accessible name. -->
    <div class="denied__mark">
      <span class="denied__pulse" aria-hidden="true"></span>
      <span class="denied__pulse denied__pulse--late" aria-hidden="true"></span>
      <app-brand-logo class="denied__logo" [src]="logoUrl()" [name]="logoAlt()" />
    </div>
  } @else {
    <app-brand-logo class="denied__logo" [src]="logoUrl()" [name]="logoAlt()" />
  }
}

<p class="denied__eyebrow">{{ eyebrow() }}</p>

<h1 class="denied__title">{{ heading() }}</h1>

<!-- The refused account, bolded by the caller: it is the fact the visitor
     came here to learn. -->
<p class="denied__body"><ng-content /></p>

<p class="denied__advisory">{{ advisory() }}</p>

<button type="button" class="denied__action" (click)="action.emit()">{{ actionLabel() }}</button>

<div class="denied__rule"></div>

<p class="denied__link"><span>Need help?</span><span>Contact Davaco support</span></p>

@if (code() !== "") {
  <p class="denied__code">{{ code() }}</p>
}
